import axios from 'axios';
import store from '../../store/store';

export default () => {
  const { config } = store.getState((state) => state);

  return axios.create({
    baseURL: config.LOGIN_URL,
    headers: {
      'Content-type': 'application/json',
      Authorization: 'jwt-token',
    },
  });
};
